import React from 'react';
import FooterContainer from './style';

function FooterMenuBar() {
  return (
    <FooterContainer>
      <img src="/images/logos/SPA_Vetor_White.png" alt="Spa logo" />
      <span>© 2021 - SPA Digital</span>
    </FooterContainer>
  );
}

export default FooterMenuBar;
